const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the user contextmenu component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('userContextmenu', ['Application','appConfiguration', function (Application, appConfiguration) {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      hmenu: '=',
      usercontextvisibility: '=?',
      setusercontextvisibility: '=?'
    },
    template: require('../../templates/directives/user-contextmenu.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      self.open = false;
      self.shim = false;
      self.flags = {};

      self.flags = Application.features.flags();

      self.hublinks = appConfiguration.hubLinks;

      self.sendToExternalPage = function(url){
        window.open(url, '_blank');
      };

      self.toggle = function($event) {
        let newval = !self.open
        self.open = newval;
        self.toggleShim($event);
        $scope.setusercontextvisibility(newval)
      };

      self.toggleShim = function($event) {

        $event.stopPropagation();
        self.shim = !self.shim;

        if ($event.currentTarget.classList.contains('shim')) {
          self.open = !self.open;
          $scope.setusercontextvisibility(self.open)
        }

      };

      $scope.$watch('usercontextvisibility', (nv, ov) => {
        if (nv === ov) return;
        self.open = nv;
        self.shim = nv;
      });

    }],
    controllerAs: 'contextMenu'
  };
}]);
